<template>
  <div class="app-main">
    <transition name="fade"  mode="out-in">
      <!-- <keep-alive> -->
      <router-view class="view-area"></router-view>
      <!-- </keep-alive> -->
    </transition>
  </div>
</template>


<script>
export default {
  computed: {
    home() {
      return this.$route.name == 'Home'? 'app-main-home' : ''
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.app-main {
  width: 100%;
  height: 100%;
  background: rgba(248, 249, 251, 1);
  margin-top: 48px;
  // margin-bottom: 30px;
  padding-bottom: 198px;/*等于footer的高度*/
}
</style>
